import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=ca831592&scoped=true&"
import script from "./Permission.vue?vue&type=script&lang=ts&"
export * from "./Permission.vue?vue&type=script&lang=ts&"
import style0 from "./Permission.vue?vue&type=style&index=0&id=ca831592&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca831592",
  null
  
)

export default component.exports